/**
 * Футер UnifiedPaywall и подсказки trial. Основной текст — `paywallReasonCopy.ts`.
 */

export const UNIFIED_PAYWALL_FOOTER = "Можно отменить в любой момент";

export const PAYWALL_TRIAL_ALREADY_USED = "Пробный период уже использован";
export const PAYWALL_TRIAL_ACTIVE_HINT = "У вас активен пробный период";
export const PAYWALL_TRIAL_ENDS_TODAY = "Пробный период закончится сегодня";
export const PAYWALL_TRIAL_ENDS_TOMORROW = "Пробный период закончится завтра";
